import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypeAheadComponent } from './type-ahead/type-ahead.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountFormComponent } from './account-form/account-form.component';
import { StripeCustomerPaymentMethodsComponent } from './stripe-customer-payment-methods/stripe-customer-payment-methods.component';
import { StripePaymentComponent } from './stripe-payment/stripe-payment.component';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { VideoPlayerComponent } from './video-player/video-player.component';

import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { LineChart, PieChart, BarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  VisualMapComponent
} from 'echarts/components';
// Import the Canvas renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer
} from 'echarts/renderers';
import { SecureDocumentPopoverComponent } from './secure-documents/secure-document-popover/secure-document-popover.component';
import { SecureDocumentsComponent } from './secure-documents/secure-documents.component';
import { LegendPopoverComponent } from './legend-popover/legend-popover.component';
import { CustomNotificationComponent } from './custom-notification/custom-notification.component';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer, PieChart, BarChart, LegendComponent, VisualMapComponent]
);

const components = [
  TypeAheadComponent,
  AccountFormComponent,
  StripeCustomerPaymentMethodsComponent,
  StripePaymentComponent,
  VideoPlayerComponent,
  SecureDocumentPopoverComponent,
  SecureDocumentsComponent,
  LegendPopoverComponent,
  CustomNotificationComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxStripeModule.forRoot(environment.stripe.forceTestPayment ? environment.stripe.testPublishableKey : environment.stripe.publishableKey),
    NgxEchartsModule.forRoot({ echarts }),
    PdfViewerModule,
  ]
})
export class SharedComponentsModule {}
